import { render, staticRenderFns } from "./graph.vue?vue&type=template&id=a2c2232e&scoped=true"
import script from "./graph.vue?vue&type=script&lang=js"
export * from "./graph.vue?vue&type=script&lang=js"
import style0 from "./graph.vue?vue&type=style&index=0&id=a2c2232e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c2232e",
  null
  
)

/* custom blocks */
import block0 from "./graph.vue?vue&type=custom&index=0&blockType=i18n&lang=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HHighchart: require('/home/runner/work/frontpages/frontpages/component-library/src/components/wrappers/h-highchart.vue').default})
